/**
 * YouTube URL helpers — the single home for video-id extraction (formerly an
 * inline regex in DuelSubmit.svelte, which is being retired with the Curation
 * Duels rework). Used by the creator-catalog Add-a-Song flow and anywhere else
 * that needs an id or thumbnail from a pasted YouTube URL.
 */

/**
 * Extract the 11-character video id from any common YouTube URL form:
 * `watch?v=`, `youtu.be/`, and `shorts/` — extra query params tolerated.
 * Returns null when no id can be found.
 */
export function extractYoutubeId(url: string): string | null {
  const m =
    url.match(/[?&]v=([a-zA-Z0-9_-]{11})/) ||
    url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/) ||
    url.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : null;
}

/**
 * Medium-quality thumbnail (320×180) for a video id — same host/size the
 * Search page already renders, so it stays cache-friendly.
 */
export function youtubeThumbUrl(id: string): string {
  return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
}
